module.exports = __webpack_public_path__ + "img/bg.f32eab48.png";